module.exports = __webpack_public_path__ + "img/unicons.f5dd903.svg";